import { emptyToUndefined } from '@/app/_lib/utils';

/**
 * Extracts a 2-letter locale from a URL pathname.
 * Matches /de/..., /en/..., etc. Falls back to defaultLocale.
 */
export function extractLocaleFromPathname(pathname: string, defaultLocale = 'de'): string {
  const match = /^\/([a-z]{2})(\/|$)/.exec(pathname);
  return match?.[1] ?? defaultLocale;
}

/**
 * Looks up a label by key with fallback chain: value → fallback → key.
 * Empty strings are skipped so a blank label falls through to the next step.
 */
export function resolveLabel(labels: Record<string, string>, key: string, fallback?: string): string {
  return emptyToUndefined(labels[key]) ?? emptyToUndefined(fallback) ?? key;
}
